import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Capitalizes the first letter of a string
 * @param str - String to capitalize
 * @returns Capitalized string
 */
function capitalize(str) {
    if (!str)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Combines class names using clsx and tailwind-merge for optimal Tailwind CSS class handling
 * @param inputs - Class values to combine
 * @returns Merged class string
 */
function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export { capitalize, cn };
//# sourceMappingURL=formatters.js.map
